<script lang="ts">
	import {
		Accordion,
		AccordionContent,
		AccordionItem,
		AccordionTrigger
	} from "#lib/web-ui/ui/accordion/index.js";
	import {
		Dialog,
		DialogContent,
		DialogDescription,
		DialogTitle
	} from "#lib/web-ui/ui/dialog/index.js";
	import { getGlossaryContext } from "./glossary-context.svelte";

	const glossary = getGlossaryContext();
</script>

<Dialog bind:open={glossary.open}>
	<DialogContent class="max-h-[85vh] overflow-y-auto sm:max-w-xl" data-testid="glossary-dialog">
		<DialogTitle class="text-foreground text-xl font-semibold">
			{glossary.copy.dialogTitle}
		</DialogTitle>
		<DialogDescription class="text-muted-foreground text-sm">
			{glossary.copy.dialogDescription}
		</DialogDescription>
		{#each glossary.groups as group (group.key)}
			{@const entries = glossary.termsInGroup(group.key)}
			{#if entries.length > 0}
				<div>
					<p class="text-primary text-xs font-semibold tracking-wide uppercase">
						{group.title}
					</p>
					<Accordion type="single" class="mt-2">
						{#each entries as entry (entry.key)}
							<AccordionItem value={entry.key}>
								<AccordionTrigger class="text-foreground">
									{entry.term}
								</AccordionTrigger>
								<AccordionContent>
									{#if entry.aliases.length > 0}
										<p class="text-muted-foreground text-xs">
											{glossary.copy.alsoKnownAsLabel}
											{entry.aliases.join(", ")}
										</p>
									{/if}
									<p class="text-foreground mt-2 text-sm">{entry.explanation}</p>
									{#if entry.example}
										<p class="text-muted-foreground mt-2 text-sm">
											{entry.example}
										</p>
									{/if}
									{#if entry.whyItMatters}
										<p
											class="text-primary mt-3 text-xs font-semibold tracking-wide uppercase"
										>
											{glossary.copy.whyLabel}
										</p>
										<p class="text-foreground mt-1 text-sm">
											{entry.whyItMatters}
										</p>
									{/if}
								</AccordionContent>
							</AccordionItem>
						{/each}
					</Accordion>
				</div>
			{/if}
		{/each}
	</DialogContent>
</Dialog>
